import React from 'react';

/**
 * 右侧地图容器（样式切换 + 定位按钮）
 */
export default function RescuePushMapPane({
  mapContainerRef,
  mapType,
  switchMapStyle,
  flyToCurrentLocation,
  compact = false
}) {
  return (
    <div
      style={{
        flex: 1,
        minWidth: compact ? 320 : 280,
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        marginLeft: compact ? 12 : 0
      }}
    >
      <div
        style={{
          position: 'relative',
          height: 'calc(100vh - 320px)',
          minHeight: 600,
          border: '1px solid #ccc',
          borderRadius: 6,
          flex: 1
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 10,
            left: 10,
            zIndex: 20,
            display: 'flex',
            gap: 4,
            background: 'rgba(255, 255, 255, 0.95)',
            borderRadius: 6,
            padding: 4,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
        >
          <button
            onClick={() => switchMapStyle('mapbox://styles/mapbox/streets-v11')}
            style={{
              padding: '6px 10px',
              background: mapType === 'mapbox://styles/mapbox/streets-v11' ? '#1976d2' : '#fff',
              color: mapType === 'mapbox://styles/mapbox/streets-v11' ? '#fff' : '#333',
              border: '1px solid #1976d2',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            街道
          </button>
          <button
            onClick={() => switchMapStyle('mapbox://styles/mapbox/satellite-v9')}
            style={{
              padding: '6px 10px',
              background: mapType === 'mapbox://styles/mapbox/satellite-v9' ? '#1976d2' : '#fff',
              color: mapType === 'mapbox://styles/mapbox/satellite-v9' ? '#fff' : '#333',
              border: '1px solid #1976d2',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            卫星
          </button>
          <button
            onClick={() => switchMapStyle('mapbox://styles/mapbox/satellite-streets-v12')}
            style={{
              padding: '6px 10px',
              background: mapType === 'mapbox://styles/mapbox/satellite-streets-v12' ? '#1976d2' : '#fff',
              color: mapType === 'mapbox://styles/mapbox/satellite-streets-v12' ? '#fff' : '#333',
              border: '1px solid #1976d2',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            卫星+道路
          </button>
        </div>

        <div
          ref={mapContainerRef}
          style={{
            height: '100%',
            width: '100%',
            borderRadius: 6,
            position: 'absolute',
            top: 0,
            left: 0
          }}
        />

        <div
          style={{
            position: 'absolute',
            bottom: 20,
            left: 20,
            zIndex: 20,
            background: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '50%',
            width: 40,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            transition: 'all 0.2s ease'
          }}
          onClick={flyToCurrentLocation}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.1)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
          }}
          title="定位到当前位置"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#1976d2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
            <circle cx="12" cy="9" r="2.5" />
          </svg>
        </div>
      </div>
    </div>
  );
}
